import TableContainer from "components/Common/TableContainer"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Col, Collapse, Container, Row } from "reactstrap"
import { getActivitySummary } from "store/actions"
import { StartDateactivity, StartMinusactivity } from "./VerifyScreenCol"
import moment from "moment"
import classnames from "classnames"

const Activity_summary = props => {
  const {
    summarydata,
    selectToggle,
    summarydatasteam,
    sethandleAccordionsummary,
    handleAccordionsummary,
  } = props

  const dispatch = useDispatch()
  useEffect(() => {
    const date = selectToggle ? summarydata?.workReportSummary?.date :  summarydatasteam?.date;
    const summarydatadate = moment(date || new Date()).format("YYYY-MM-DD")
    const userTeams = {
      userid: selectToggle ? summarydata?.userId : 0,
      subcategoryId: !selectToggle ? summarydatasteam?.projectId : 0,
      date: summarydatadate,
    }
        dispatch(getActivitySummary(userTeams))
  }, [])

  const { activitysummary } = useSelector(state => ({
    activitysummary: state.timesheet?.activitysummarySuccessList,
  }))

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Date",
        accessor: "startDate",
        disableFilters: true,
        filterable: true,
        width: 75,
        Cell: cellProps => {
          return <StartDateactivity {...cellProps} />
        },
      },
      {
        Header: "Application Name",
        accessor: "applicationname",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Mouse Clicks",
        accessor: "mouseClicks",
        disableFilters: true,
        filterable: true,
        width: 90,
      },

      {
        Header: "KeyPress",
        accessor: "keyPress",
        disableFilters: true,
        filterable: true,
        width: 60,
      },

      {
        Header: "Duration",
        accessor: "durationinseconds",
        disableFilters: true,
        width: 60,
        filterable: true,
        Cell: cellProps => {
          return <StartMinusactivity {...cellProps} />
        },
      },
    ]
    return result
  }, [selectToggle])

  const handleOnclickAccordion = value => {
    if (handleAccordionsummary === value) {
      sethandleAccordionsummary(null)
    } else {
      sethandleAccordionsummary(value)
    }
  }

  return (
    <React.Fragment>
      <div>
        <Container>
          <Row>
            <Col xs="12" className="activity-summery table-mobileView">
              {selectToggle && (
                <TableContainer
                  keyField="id"
                  data={activitysummary?.[0]?.activitySummary || []}
                  columns={columns}
                  hidepagination={true}
                                  />
              )}
              {!selectToggle && (
                <>
                  {activitysummary?.length === 1 ? (
                    <TableContainer
                      keyField="id"
                      data={activitysummary?.[0]?.activitySummary || []}
                      columns={columns}
                      hidepagination={true}
                    />
                  ) : (
                    <>
                      {activitysummary?.map((summary, id) => (
                        <div className="accordion p-2" id="accordion" key={id}>
                          <div className="accordion-item mb-2">
                            <h2 className="accordion-header" id="headingOne">
                              <button
                                className={classnames(
                                  "accordion-button",
                                  "fw-medium",
                                  {
                                    collapsed: handleAccordionsummary !== id,
                                  }
                                )}
                                type="button"
                                onClick={() => handleOnclickAccordion(id)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="d-flex d-flex-justspace mobile_accordian">
                                  <div>
                                    Name :{" "}
                                    <span className="addposition">
                                      {summary?.userName}
                                    </span>
                                  </div>
                                </div>
                              </button>
                            </h2>

                            <Collapse
                              isOpen={handleAccordionsummary === id}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <div className="text-muted">
                                  <Row>
                                    <Col md="12" className="table-mobileView">
                                      <TableContainer
                                        keyField="id"
                                        data={
                                          activitysummary?.[id]
                                            ?.activitySummary || []
                                        }
                                        columns={columns}
                                        hidepagination={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Collapse>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
              {activitysummary?.length == 0 && (
                <div className="text-center">
                  No Records Found
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Activity_summary
